;(function ($) {
    /**
     * ele: 公司input class或ID
     * */
    window.ifMatchingcompanyName = false; // gio埋码 默认不是联想出来的公司名称
    window.selectCompany = function (ele) {
        this.eleCon = document.querySelector(ele); // 公司input
        this.selectCompanyClass = '.company_select_cont'; // 公司联想下拉框的class
        this.cpLock = true; // 公司联想拼音阶段
        this.inputValue = true; // 公司联想拼音阶段
        this.inputChange(ele); // 监听输入框的变化
        $("body").not(".company_select_cont li").click(function () {
            $(".company_select_cont").hide();
        });
    };
    window.selectCompanyGio = function (phone) { // gio 表单提交成功
        window.gio('track', 'QCCcompany_formsubmitsuccess', {
            'ifMatchingcompanyName': window.ifMatchingcompanyName,
            'phoneNumber': common.mobileEncryption(phone),
        });
    };

    // 判断2个汉字
    window.selectCompany.prototype.isTwoChinese = function (val) {
        return !!val.match(/[^\x00-\xff]/ig) && val.match(/[^\x00-\xff]/ig).length >= 2;
    };
    // 监控company input的输入值变化
    window.selectCompany.prototype.inputChange = function (ele) {
        var _this = this;
        $(ele).bind('input porpertychange', function (e) {
            setTimeout(function () {
                var value = e.target.value;
                window.ifMatchingcompanyName = false;
                if (!_this.isTwoChinese(value) || !_this.cpLock || _this.inputValue === value) return; // 不满足两个汉字以上
                _this.companyList(value);
            }, 0)
        });
        // 屏蔽拼音阶段
        $(ele).bind('compositionstart', function (e) {
            _this.cpLock = false;
        });
        $(ele).bind('compositionend', function (e) {
            _this.cpLock = true;
        });

    };
    // 公司联想接口调用
    window.selectCompany.prototype.companyList = function (val) {
        var _this = this;
        // 防止调用多次接口
        _this.inputValue = val;
        common.getJson(window.solution_host + '/api/search/company', {
            kw: val
        }, function (res) {
            if (res.errCode === 0) {
                window.gio('track', 'QCCcompany_impressions');
                _this.companyLi(res.data);
            } else {
                window.solution_msg.toast(res.msg);
            }
        })
    };

    // 公司联想下拉值拼接
    window.selectCompany.prototype.companyLi = function (list) {
        if (list.length === 0) return;
        $(this.selectCompanyClass).remove(); // li值重置
        var liStr = '';
        list.forEach(function (value) {
            liStr = liStr + '<li>' + value + '</li>';
        });
        var selectStr = '<ul class="company_select_cont" style="display: none;">' + liStr + '</ul>';
        this.eleCon.insertAdjacentHTML('afterEnd', selectStr);
        this.companyConPosition();
        this.companyLiClick();
    };

    // 公司联想下拉框的定位
    window.selectCompany.prototype.companyConPosition = function () {
        var _this = this;
        $(_this.selectCompanyClass).css({
            'right': 0,
            'top': _this.eleCon.offsetHeight,
            'display': 'block',
        });
    };

    // 联想值的点击效果
    window.selectCompany.prototype.companyLiClick = function () {
        var _this = this;
        $(_this.selectCompanyClass + ' li').click(function () {
            window.gio('track', 'QCCcompany_click');
            _this.eleCon.value = $(this).text();
            $(_this.selectCompanyClass).hide();
            window.ifMatchingcompanyName = true;
        });
    };
})(jQuery);
